import TextField from "@mui/material/TextField";
import AddItemDialog from "../../Dialogs/AddItemDialog";
import { useEffect, useState } from "react";
import { ExamInterface } from "../../../interfaces/examInterfaces";
import { useSelector } from "react-redux";
import { RootState } from "../../..";
import { useLocation } from "react-router-dom";
import { createErrorText } from "../Functions";

const RenameExamDialog = ({
  open,
  renameExam,
  handleCancel,
  currentName,
}: {
  open: boolean;
  renameExam: (newName: string, examData?: ExamInterface) => void;
  handleCancel: () => void;
  currentName: string | undefined;
}) => {
  const [name, setName] = useState("");
  const examData = useSelector((state: RootState) => state.examBuilder.main.examData);
  const paths = useSelector((state: RootState) => state.examOverview.paths);
  const location = useLocation();
  const pathString = decodeURI(location.pathname.replace(/\/(exam-builder|exam-overview)/, "")) || "/";
  const [errorText, setErrorText] = useState<string | null>(null);

  const resetFields = () => {
    if (!open) {
      setName("");
    } else if (currentName) {
      setName(currentName);
    }
  };

  const handleRenameExam = (name: string) => {
    renameExam(name, examData);
  };

  useEffect(() => {
    resetFields();
  }, [open]);

  useEffect(() => {
    setErrorText(createErrorText(paths, pathString, name));
  }, [name]);

  return (
    <AddItemDialog
      open={open}
      handleCancel={() => handleCancel()}
      handleConfirm={() => handleRenameExam(name)}
      title={"Prüfung umbenennen"}
      description={"Wähle einen neuen Namen"}
      confirmText={"OK"}
      confirmAllowed={errorText === null}
    >
      <TextField
        margin="dense"
        id="name"
        label="Name"
        required
        error={errorText !== null}
        style={{ width: 330 }}
        autoFocus
        value={name}
        onChange={(e) => {
          setName(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.code === "Enter" && errorText === null) {
            handleRenameExam(name);
          }
        }}
        helperText={errorText ?? errorText}
      />
    </AddItemDialog>
  );
};

export default RenameExamDialog;
